import React from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal, Form } from 'react-bootstrap';

import PieBasicChart from 'components/common/chart/PieBasicChart';
import StackedLineChart from 'components/common/chart/StackedLineChart';
import EstimatedCost from './EstimatedCost';

const SummaryReport = () => {
  const [showDefaultModal, setShowDefaultModal] = useState(false);

  const [totalPrice, setTotalPrice] = useState(0);
  const [totalCarbonOffset, setTotalCarbonOffset] = useState(0);
  const [individualPrice, setIndividualPrice] = useState(30);
  const [individualCarbonOffset, setIndividualCarbonOffset] = useState(22);
  const [mappedChartDataSource, setMappedChartDataSource] = useState([]);
  const { plantingDataSource } = useSelector(state => state.landDev);

  const calculateReport = () => {
    setShowDefaultModal(false);

    let tempTotalPrice = 0;
    let tempTotalCarbonOffset = 0;
    let mappedData = []; // a stripped down version of plantingDataSource, for chart display

    for (let i = 0; i < plantingDataSource.length; i++) {
      // sum up total price and numberOfItems
      tempTotalPrice += individualPrice * plantingDataSource[i].numberOfItems;
      tempTotalCarbonOffset +=
        individualCarbonOffset * plantingDataSource[i].numberOfItems;

      for (let j = 0; j < mappedData.length; j++) {
        if (plantingDataSource[i].name === mappedData[j].name) {
          // name already exist in mappedData, don't push new object, just add up numberOfItems
          mappedData[j].value += Number(plantingDataSource[i].numberOfItems);
          break;
        } else {
          mappedData.push({
            name: plantingDataSource[i].name,
            value: plantingDataSource[i].numberOfItems
          });
          break;
        }
      }

      // initialize mappedData with the first item in plantingDataSource
      if (mappedData.length === 0) {
        mappedData.push({
          name: plantingDataSource[i].name,
          value: plantingDataSource[i].numberOfItems
        });
      }
    }

    setTotalPrice(tempTotalPrice);
    setTotalCarbonOffset(tempTotalCarbonOffset);
    setMappedChartDataSource(mappedData);
  };

  useEffect(() => {
    calculateReport();
  }, [plantingDataSource]);

  const handleCloseModal = () => {
    setShowDefaultModal(false);
  };

  const handleOpenModal = () => {
    setShowDefaultModal(true);
  };

  const currentYear = new Date().getFullYear();
  const nextTenYears = Array.from(
    { length: 10 },
    (_, index) => currentYear + index
  );

  const Co2DataSource = plantingDataSource.map(item => ({
    name: item.name,
    type: 'line',
    symbolSize: 10,
    symbol: 'circle',
    stack: 'product',
    data: [
      120 + item.numberOfItems,
      132 + item.numberOfItems,
      101 + item.numberOfItems,
      134 + item.numberOfItems,
      200 + item.numberOfItems,
      230 + item.numberOfItems,
      210 + item.numberOfItems,
      323 + item.numberOfItems,
      400 + item.numberOfItems,
      450 + item.numberOfItems
    ]
  }));

  const priceStat = {
    title: 'Estimated Total Cost',
    value: totalPrice,
    decimal: true,
    prefix: '$',
    valueClassName: 'text-warning',
    badgeBg: 'warning',
    link: 'paths.customers',
    linkText: 'See all'
  };

  const carbonStat = {
    title: 'Estimated Carbon Offset',
    value: totalCarbonOffset,
    decimal: false,
    suffix: 'KG',
    valueClassName: 'text-warning',
    badgeBg: 'warning',
    link: 'paths.customers',
    linkText: 'See all'
  };

  return (
    <>
      <Button variant="primary" onClick={handleOpenModal}>
        Edit defaults
      </Button>

      <hr />

      {mappedChartDataSource.length && (
        <>
          <EstimatedCost stat={priceStat}></EstimatedCost>
          <PieBasicChart plantingDataSource={mappedChartDataSource} />
          <StackedLineChart
            xAxisData={nextTenYears}
            seriesData={Co2DataSource}
          ></StackedLineChart>
          <br /> <br /> <hr />
          <EstimatedCost stat={carbonStat}></EstimatedCost>
          <br />
          <StackedLineChart
            xAxisData={nextTenYears}
            seriesData={Co2DataSource}
          ></StackedLineChart>
        </>
      )}

      <Modal show={showDefaultModal} onHide={handleCloseModal} centered>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Price per tree:</Form.Label>
            <Form.Control
              max="100"
              type="number"
              value={individualPrice}
              onChange={e => setIndividualPrice(e.target.value)}
            />
            <Form.Label>Carbon Offset per tree</Form.Label>
            <Form.Control
              max="1000"
              type="number"
              value={individualCarbonOffset}
              onChange={e => setIndividualCarbonOffset(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={calculateReport}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SummaryReport;
